import { render, staticRenderFns } from "./AddVendorContract.vue?vue&type=template&id=05f95eae"
import script from "./AddVendorContract.vue?vue&type=script&lang=ts"
export * from "./AddVendorContract.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports